/**
 * Indicate that we changed of step in the step bar.
 * @type {string}
 */
export const CHANGE_ACTUAL_STEP = 'CHANGE_ACTUAL_STEP';
